import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'warning' | 'danger' | 'info';
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="confirm-dialog" [ngClass]="data.type || 'warning'">
      <div class="dialog-icon">
        <mat-icon>{{ getIcon() }}</mat-icon>
      </div>

      <h2 mat-dialog-title>{{ data.title }}</h2>

      <mat-dialog-content>
        <p>{{ data.message }}</p>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">
          {{ data.cancelText || 'Cancelar' }}
        </button>
        <button mat-raised-button [color]="getButtonColor()" (click)="onConfirm()">
          {{ data.confirmText || 'Confirmar' }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .confirm-dialog {
      text-align: center;
      padding: 8px;
    }

    .dialog-icon {
      width: 64px;
      height: 64px;
      border-radius: var(--radius-md);
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 16px;

      mat-icon {
        font-size: 32px;
        width: 32px;
        height: 32px;
      }
    }

    .warning .dialog-icon {
      background: rgba(255, 152, 0, 0.1);
      color: #ff9800;
    }

    .danger .dialog-icon {
      background: rgba(244, 67, 54, 0.1);
      color: #f44336;
    }

    .info .dialog-icon {
      background: rgba(33, 150, 243, 0.1);
      color: #2196f3;
    }

    h2[mat-dialog-title] {
      font-family: var(--font-display);
      margin: 0 0 8px 0;
      font-size: 20px;
      font-weight: 700;
      letter-spacing: -0.02em;
    }

    p {
      color: var(--text-secondary);
      margin: 0;
      font-size: 14px;
    }

    mat-dialog-actions {
      padding-top: 24px;
      justify-content: center;
    }
  `]
})
export class ConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  getIcon(): string {
    switch (this.data.type) {
      case 'danger': return 'error';
      case 'info': return 'info';
      default: return 'warning';
    }
  }

  getButtonColor(): 'primary' {
    return 'primary';
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}
